import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'action-bar.close-icon-label': {
    id: 'action-bar.close-icon-label',
    defaultMessage: 'Close',
    description: 'This message is shown as a label to the close icon button'
  },
  'action-bar.selected-count': {
    id: 'action-bar.selected-count',
    defaultMessage: '{count} selected',
    description:
      'This message is shown to describe the total count of selected cells, fields, or entries'
  },
  'action-bar.single-entry-copy-link': {
    id: 'action-bar.single-entry-copy-link',
    defaultMessage: 'Copy link',
    description:
      'This message is shown on the action button to indicate that it will copy the selected entry link when clicked'
  },
  'action-bar.single-entry-copied-tooltip': {
    id: 'action-bar.single-entry-copied-tooltip',
    defaultMessage: 'Copied!',
    description: 'This tooltip message is shown after a user clicks on copy link button'
  },
  'action-bar.single-entry-expand-entry': {
    id: 'action-bar.single-entry-expand-entry',
    defaultMessage: 'Expand',
    description:
      'This message is shown on the action button indicate that this will expand entry details panel when clicked'
  },
  'action-bar.single-entry-duplicate-action': {
    id: 'action-bar.single-entry-duplicate-action',
    defaultMessage: 'Duplicate',
    description:
      'This message is shown on the action button indicate that this will duplicate the row when clicked'
  },
  'action-bar.single-entry-add-button': {
    id: 'action-bar.single-entry-add-button',
    defaultMessage: 'Add new',
    description:
      'This message is shown on the action button indicate that this will open the add menu when clicked'
  },
  'action-bar.single-entry-add-entry-above-action': {
    id: 'action-bar.single-entry-add-entry-above-action',
    defaultMessage: 'Add entry above',
    description:
      'This message is shown on the action button indicate that this will add the entry row above when clicked'
  },
  'action-bar.single-entry-add-entry-below-action': {
    id: 'action-bar.single-entry-add-entry-below-action',
    defaultMessage: 'Add entry below',
    description:
      'This message is shown on the action button indicate that this will add the entry row below when clicked'
  },
  'action-bar.single-entry-move-button': {
    id: 'action-bar.single-entry-move-button',
    defaultMessage: 'Move',
    description:
      'This message is shown on the action button indicate that this will open the move menu when clicked'
  },
  'action-bar.single-entry-move-entry-up-action': {
    id: 'action-bar.single-entry-move-entry-up-action',
    defaultMessage: 'Move entry up',
    description:
      'This message is shown on the action button indicate that this will move the entry row up when clicked'
  },
  'action-bar.single-entry-move-entry-down-action': {
    id: 'action-bar.single-entry-move-entry-down-action',
    defaultMessage: 'Move entry down',
    description:
      'This message is shown on the action button indicate that this will move the entry row down when clicked'
  },
  'action-bar.multiple-entries-move-up-action': {
    id: 'action-bar.multiple-entries-move-up-action',
    defaultMessage: 'Move entries up',
    description:
      'This message is shown on the action button indicate that this will move the entries row up when clicked'
  },
  'action-bar.multiple-entries-move-down-action': {
    id: 'action-bar.multiple-entries-move-down-action',
    defaultMessage: 'Move entries down',
    description:
      'This message is shown on the action button indicate that this will move the entries row down when clicked'
  },
  'action-bar.chevron.down.icon.label': {
    id: 'action-bar.chevron.down.icon.label',
    defaultMessage: 'chevron down icon label',
    description: 'This message is the label for chevron down icon'
  },
  'action-bar.clear-values-action': {
    id: 'action-bar.clear-values-action',
    defaultMessage: 'Clear values',
    description:
      'This message is shown on the action button indicates that this will clear the values of selected cells'
  },
  'action-bar.single-entry-delete-action': {
    id: 'action-bar.single-entry-delete-action',
    defaultMessage: 'Delete',
    description:
      'This message is shown on the action button indicate that this will delete the selected entry'
  },
  'action-bar.field-duplicate-action': {
    id: 'action-bar.field-duplicate-action',
    defaultMessage: 'Duplicate',
    description:
      'This message is shown on the action button to indicate that it will duplicate the selected fields'
  },
  'action-bar.field-delete-action': {
    id: 'action-bar.field-delete-action',
    defaultMessage: 'Delete',
    description:
      'This message is shown on the action button to indicate that it will delete the selected fields'
  },
  'action-bar.field-move-left-action': {
    id: 'action-bar.field-move-left-action',
    defaultMessage: 'Move fields left',
    description:
      'This message is shown on the dropdown item to indicate that it will move the selected fields to the left'
  },
  'action-bar.field-move-right-action': {
    id: 'action-bar.field-move-right-action',
    defaultMessage: 'Move fields right',
    description:
      'This message is shown on the dropdown item to indicate that it will move the selected fields to the right'
  },
  'action-bar.field-move-button': {
    id: 'action-bar.field-move-button',
    defaultMessage: 'Move',
    description:
      'This message is shown on the action button to indicate that this will open the field move menu when clicked'
  },
  'action-bar.field-hide-action': {
    id: 'action-bar.field-hide-action',
    defaultMessage: 'Hide fields',
    description:
      'This message is show on the action button to indicate that this will hide the selected fields'
  },
  'action-bar.value-delete-action': {
    id: 'action-bar.value-delete-action',
    defaultMessage: 'Delete',
    description:
      'This message is shown on the action button to indicate that it will open a delete menu when clicked'
  },
  'action-bar.value-delete-entries-action': {
    id: 'action-bar.value-delete-entries-action',
    defaultMessage: 'Delete {count, plural, one {# entry} other {# entries}}',
    description:
      'This message is shown on the action button to indicate that it will delete selected number of entries'
  },
  'action-bar.value-delete-fields-action': {
    id: 'action-bar.value-delete-fields-action',
    defaultMessage: 'Delete {count, plural, one {# field} other {# fields}}',
    description:
      'This message is shown on the action button to indicate that it will delete selected number of fields'
  },
  'action-bar.edit-values': {
    id: 'action-bar.edit-values',
    defaultMessage: 'Edit values',
    description:
      'This message is shown on the action button to indicate that it will edit the selected values'
  },
  'action-bar.ask-rovo': {
    id: 'action-bar.ask-rovo',
    defaultMessage: 'Ask Rovo',
    description:
      'This message is shown on the action button to indicate that it will trigger AI assistance when clicked'
  }
});
